import React from 'react';
import { ListItemButton, ListItemText } from '@mui/material';
import { UploadFileOutlined } from '@mui/icons-material';
import { UploadedProviderDocument, uploadedProviderDocumentTypeLabels } from '@uplift/api';
import { CalendarDateService } from '@uplift/services';
import { DateFormats } from '@uplift/constants';
import { useTimezone } from '@uplift/contexts';
import { HighlightableAvatar } from '@uplift/ui-v2';


export const UploadedProviderDocumentListItem: React.VFC<{
  document: UploadedProviderDocument;
  datetime: string;
  onClick: () => void;
  selected: boolean;
}> = ({ document, datetime, onClick, selected }) => {
  const timezone = useTimezone();

  return (
    <ListItemButton
      onClick={onClick}
      selected={selected}
      sx={selected ? { borderRight: '3px solid', borderRightColor: 'secondary.main' } : undefined}
    >
      <HighlightableAvatar variant="circular" highlighted={selected}>
        <UploadFileOutlined fontSize="small" />
      </HighlightableAvatar>
      <ListItemText
        sx={{ ml: 1 }}
        primary={uploadedProviderDocumentTypeLabels[document.documentType] ?? document.documentType}
        secondary={CalendarDateService.date(datetime).tz(timezone).format(DateFormats['MMM D, YYYY'])}
      />
    </ListItemButton>
  );
};
